import { render } from "./custom_arrow_sm_down.vue?vue&type=template&id=3215f5e6"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__